import {createSelector} from 'reselect';

export const getHasFailedProduct = (state) => state.userProductTypes.hasFailed

/**
 * @param {Object} state
 * @returns {boolean}
 */
export const getIsProductTypesLoaded = createSelector(
  (state) => state.userProductTypes,
  (userProductTypes) => userProductTypes.isLoaded
);

/**
 * @param {Object} state
 * @returns {boolean}
 */
export const getProductTypes = createSelector(
  (state) => state.userProductTypes,
  (userProductTypes) => (userProductTypes.entity ? userProductTypes.entity : {})
);

/**
 * @param {Object} state
 * @returns {boolean}
 */
export const getHasAPP = createSelector(
  getProductTypes,
  /**
   * @param {Object.<string, boolean>} productTypes
   * @returns {boolean}
   */
  (productTypes) => {
    const { hasAPP } = productTypes || {};
    return hasAPP;
  }
);

export const getHasOnlyTheProvidedProductType = createSelector(
  getProductTypes,
  (state, { productType }) => productType,
  /**
   * @param {Object.<string, boolean>} productTypes
   * @returns {boolean}
   */
  (productTypes, productType) => {
    const keys = Object.keys(productTypes);
    return (
      productTypes[productType] &&
      keys.every((key) => key === productType || !productTypes[key])
    );
  }
);
